import React from 'react'
import styled from 'styled-components/macro'
import { layout, space } from 'styled-system'

import { ColorsMap } from '@/utils/Theme'

export const InputNumber = styled.input`
  ${layout}
  ${space}
  max-width: 3rem;
  border: 1px solid;
  border-radius: 2rem;
  text-align: center;
  color: ${ColorsMap.primary};
  margin: 0 0.5rem;
`

interface NumberProps {
  value?: number
}

export const Number: React.FC<NumberProps> = ({ value, ...props }) => (
  <InputNumber {...props} type="number" value={value} />
)
